module.exports = "fragment StripeSourceFragment on StripeSource {\n  __typename\n  ...CreditCardFragment\n}\n"